var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[(_vm.type === 'image')?_c('el-image',{attrs:{"src":_vm.src,"fit":"contain"}}):_vm._e(),(_vm.type === 'video')?_c('VideoPlayer',{attrs:{"src":_vm.src}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }